/* Mottakerregister for Frontier-decket: merkevarefarge (deckets eneste aksent), førstelinje i «Why» og påstander vi kan stå
   inne for (verifisert sep. 2026). Logoene ligger i det felles registeret (../headliner/brands.js). Ukjent lab → tekst + gul. */
import { logoOf } from "../headliner/brands";

export const BRANDS = {
  openai: {
    color: null,
    first: "Stargate Norway puts OpenAI's compute outside Narvik. The summit puts OpenAI's conversation in front of the leaders who decide what runs on it.",
  },
  microsoft: {
    color: "#0078d4",
    first: "Two Norwegian cloud regions since 2019, and Copilot already inside many of the organisations in the room — the summit is where that goes from tool to strategy.",
  },
  google: {
    color: "#4285f4",
    first: "A €600 million data centre under construction in Skien, and Gemini and Google Cloud in the market — the summit is where the two meet the decision-makers.",
  },
  anthropic: {
    color: "#d97757",
    first: "Enterprise-first and safety-first — a positioning that matches a room that asks about trust before capability.",
  },
  meta: {
    color: "#0081fb",
    first: "Open models put the frontier in the hands of every organisation in the room — the summit is where that argument reaches the board.",
  },
  mistral: {
    color: "#ff7000",
    first: "Europe's frontier lab in a European room — sovereignty, openness and proximity as the argument.",
  },
  aws: {
    color: "#ff9900",
    first: "The infrastructure much of the room already runs on — the summit is where AI on it becomes a board-level decision.",
  },
};

export const brandOf = (name) => {
  const b = BRANDS[(name || "").trim().toLowerCase()];
  return { name, color: null, first: null, logo: logoOf(name), ...b };
};

export const brandRootStyle = (name) => {
  const b = brandOf(name);
  return b.color ? { "--hd-gul": b.color, "--bd-brand": b.color } : undefined;
};

export const whyFor = (m) => {
  const first = brandOf(m).first;
  const pts = [
    ["The buyers, not the builders", "700 CEOs, board members, CFOs and owners — the people who decide what their organisations deploy, on which platform, under which rules."],
    ["Trust before capability", "A room that asks about accountability, data and sovereignty — the questions a frontier lab needs to answer in person."],
    ["One lab. No competitor.", `Category exclusivity: ${m} is the only frontier lab or hyperscaler in the summit's partner programme.`],
  ];
  return first ? [[`Why ${m}`, first], ...pts] : pts;
};
